module.exports = "/../../dist/frontend/images/vehicule_remplacement.webp?bb7378e513962a297bd930c748b1dec3";